<template>
    <div>
        <MenuAccount_Main/>
        <AccountDayList/>
    </div>
</template>

<script>

import MenuAccount_Main from '@/components/menuadmin/account/accountheader/MenuAccount_Main.vue'
import AccountDayList from '@/components/menuadmin/account/accountcreate/AccountDayList.vue'
export default {
    name:'accountDay',
    components:{
        MenuAccount_Main,
        AccountDayList,
    },
}
</script>